<template>
  <layout :title="pageTitle">
    <b-tabs>
      <b-tab-item label="Projects">
        <b-field>
          <inertia-link
            :href="route('projects.create')"
            class="is-pulled-right mb-3"
          >
            <b-button class="is-primary" size="is-small" icon-left="plus">
              Add Project
            </b-button>
          </inertia-link>
        </b-field>
        <view-projects-table :projects="active" />
      </b-tab-item>
      <b-tab-item label="Trashed">
        <view-projects-table :projects="trashed" />
      </b-tab-item>
    </b-tabs>
  </layout>
</template>

<script>
import Layout from './Layout';
import ViewProjectsTable from '@/Components/Management/ViewProjectsTable';

export default {
  components: {
    Layout,
    ViewProjectsTable,
  },
  props: {
    projects: Array,
  },
  computed: {
    active() {
      return this.projects.filter((p) => p.deleted_at === null);
    },
    trashed() {
      return this.projects.filter((p) => p.deleted_at !== null);
    },
  },
  data() {
    return {
      pageTitle: 'Manage Projects',
    };
  },
};
</script>
